// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleInjector_root__fjDeh"};